import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noComma'
})

export class NoCommaPipe implements PipeTransform {

  transform(val: number): string {
    if (val !== undefined && val !== null) {
      return val.toString().replace(/,/g, '.');
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shared/no-comma.pipe.ts